import {
    cutString,
    isNull,
} from '@/utils/main'

import {
    i18n,
} from '@/plugins/vuei8n'
import moment from 'moment'

import FileSaver from 'file-saver'

function isNotLastPage(meta) {
    return meta.current_page !== meta.last_page
}

function isNotAll(item) {
    return item !== 'all'
}

function isObject(v) {
    return typeof v === 'object'
}

function getFilters(params) {
    let query = ''

    for (const item in params) {
        if (isObject(params[item]) && !isNull(params[item])) {
            // for params.shouldStartedFrom and params.shouldStartedTill
            if (
                params[item].value !== ''
                && params[item].hasOwnProperty('time')
                && !isNaN(params[item].time)
            ) {
                query += `${item}=${moment(params[item].value).format('YYYY-MM-DD')}&`
            }
        }

        // if params.status !== null etc
        if (
            !isNull(params[item])
            && !isObject(params[item])
            && isNotAll(params[item])
        ) { query += `${item}=${params[item]}&` }
    }

    // if we don't have params => return ""
    // else cut the last character
    return query === '' ? '' : `&${cutString(query, 0, query.length - 1)}`
}

const localState = {
    orders: null,
    meta: {
        current_page: 0,
        last_page: null,
        per_page: 40,
    },
    sortBy: '',
    orderBy: '',
    params: {
        status: null,
        service_id: null,
        partnerId: null,
        priceFrom: 0,
        priceTill: 1500,
        predictedTimeFrom: null,
        predictedTimeTill: null,
        email: null,
        phone: null,
        isPaid: null,
        shouldStartedFrom: {
            value: '',
            time: null,
        },
        shouldStartedTill: {
            value: '',
            time: null,
        },
        search: null,
        paymentType: null,
        companyRating: null,
        masterRating: null,
        source: null,
    },
    selectSettings: {
        services: {
            placeholder: i18n.t('listsHeader.service'),
        },
        partners: {
            placeholder: i18n.t('navigation.partners'),
        },
        ratings: {
            placeholder: i18n.t('ordersStatus.rating_review'),
        },
        paid: {
            placeholder: i18n.t('listsHeader.paid'),
        },
        masters: {
            placeholder: i18n.t('navigation.masters'),
        },
        statuses: {
            placeholder: i18n.t('listsHeader.status'),
        },
    },
    newOrders: null,
    showModal: false,
    order: null,
    statuses: null,
    load: false,
    snackbar: {
        show: false,
        data: {
            id: '13bb85b0-1b02-4d74-be13-b765643b33a3',
        },
    },
    extraPrices: null,
    minMax: null,
    availableDays: [],
}

const mutations = {
    setNewOrders: (state, {
        data: {
            qty_new_requests,
        },
    }) => {
        state.newOrders = qty_new_requests
    },
    setOrders: (state, {
        isFilter,
        orders,
    }) => {
        if (isNull(state.orders) || isFilter === true) state.orders = orders
        else {
            const data = state.orders
            state.orders = data.concat(orders)
        }
    },
    setOrder: (state, v) => {
        state.order = v
    },
    setSort: (state, {
        sortBy,
        orderBy,
    }) => {
        state.sortBy = sortBy
        state.orderBy = orderBy
    },
    setParams: (state, v) => {
        state.params = v
    },
    setMeta: (state, v) => {
        state.meta = v
    },
    incPage: (state, v) => {
        state.meta.current_page = v === null ? ++state.meta.current_page : v
    },
    setToggleModal: (state) => {
        state.showModal = !state.showModal
    },
    setToggleModalState: (state, v) => {
        state.showModal = v
    },
    setStatuses: (state, v) => {
        const data = []
        for (const item in v) {
            const element = v[item]

            data.push({
                status: item,
                value: element,
            })
        }
        state.statuses = data
    },
    setLoad: (state, v) => {
        state.load = v
    },
    clearOrders: (state) => {
        state.orders = null
    },
    clearParams: (state) => {
        state.meta = {
            current_page: 0,
            last_page: null,
            per_page: 40,
        }

        state.params = {
            status: null,
            service_id: null,
            partnerId: null,
            priceFrom: 0,
            priceTill: 1500,
            predictedTimeFrom: null,
            predictedTimeTill: null,
            email: null,
            phone: null,
            isPaid: null,
            shouldStartedFrom: {
                value: '',
                time: null,
            },
            shouldStartedTill: {
                value: '',
                time: null,
            },
            search: null,
            paymentType: null,
            companyRating: null,
            masterRating: null,
            source: null,
        }

        state.sortBy = ''
        state.orderBy = ''
    },
    setSnackbarShow: (state, v) => {
        state.snackbar.show = v
    },
    setSnackbarData: (state, v) => {
        state.snackbar.data = v
    },
    setExtraPrices: (state, v) => {
        state.extraPrices = v
    },
    setMinMaxPrice: (state, data = {}) => {
        state.params.priceFrom = data.min_final_price
        state.params.priceTill = data.max_final_price
    },
    setAvailableDays: (state, data = []) => {
        state.availableDays = data
    },
}

const actions = {
    async fetchMinMaxPrice({
        commit,
    }) {
        const response = await this.$api.orders.fetchMinMaxPrice()
        commit('setMinMaxPrice', response.data.data)
    },
    async fetch({
        commit,
        state,
    }, {
        page = null,
        // scroll = true,
        // limit = 40,
        isFilter = false,
    }) {
        try {
            if (isNotLastPage(state.meta) || isFilter) {
                commit('incPage', page)
                // console.log(state.params)
                // if (state.params.priceFrom) {

                //   state.params.priceFrom = moment(state.params.priceFrom / 1000).format("YYYY-MM-DD")
                // }

                // if (state.params.priceTill) {
                //   state.params.priceTill = moment(state.params.priceTill / 1000).format("YYYY-MM-DD")
                // }

                const response = await this.$api.orders.fetchList(
                    `?page=${state.meta.current_page}&limit=${state.meta.per_page}${getFilters(
                        state.params,
                    )}${state.sortBy}${state.orderBy}`,
                )

                commit('setOrders', {
                    v: response.data,
                    isFilter,
                    orders: response.data.data !== undefined ? response.data.data : [],
                })
                commit('setMeta', response.data.meta)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async generatePdf({ state }) {
        const response = await this.$api.orders.generatePdf(
            `?${getFilters(state.params)}${state.sortBy}${state.orderBy}`,
        )

        const file = new Blob([response.data], {
            type: response.headers['content-type'],
        })

        FileSaver.saveAs(file, 'ordersList.xlsx')
    },
    async fetchWithSavingScrollState({
        commit,
        state,
    }) {
        try {
            // if (state.params !== null) {
            //   if (state.params.priceFrom === 1) {
            //     state.params.priceFrom = 0;
            //   }
            // }
            const page = state.meta.current_page || 1
            const response = await this.$api.orders.fetchList(
                `?page=1&limit=${page * state.meta.per_page}${getFilters(
                    state.params,
                )}${state.sortBy}${state.orderBy}`,
            )

            commit('setOrders', {
                v: response.data,
                isFilter: true,
                orders: response.data.data !== undefined ? response.data.data : [],
            })
            commit('setMeta', response.data.meta)
        } catch (err) {
            console.log(err)
        }
    },

    async fetchById({
        commit,
    }, id) {
        try {
            const response = await this.$api.orders.fetchById(id)
            commit('setOrder', response.data)
            return response.data
        } catch (err) {
            console.log(err)
        }
    },

    async fetchNewOrdersCount({
        commit,
    }) {
        try {
            const response = await this.$api.requests.statistic()
            commit('setNewOrders', response.data)
        } catch (err) {
            console.log(err)
        }
    },

    async fetchAvailableDays({
        commit,
    }, form) {
        const response = await this.$api.orders.fetchAvailableDays(form)
        commit('setAvailableDays', response.data)
    },

    async fetchExtraPrice({
        commit,
    }, data) {
        try {
            const response = await this.$api.orders.fetchExtraPrices(data)
            commit('setExtraPrices', response.data.data)
        } catch (err) {
            // log err
        }
    },

    async fetchStatuses({
        commit,
    }) {
        try {
            const response = await this.$api.orders.statuses()
            commit('setStatuses', response.data.data)
        } catch (err) {
            console.log(err)
        }
    },

    async updatePaidStatus(_, id) {
        try {
            await this.$api.orders.makePaid(id)
        } catch (err) {
            console.log(err)
        }
    },

    async addTags(_, {
        id,
        form,
    }) {
        return await this.$api.orders.addTags(id, form)
    },

    async addMaterials(_, {
        id,
        form,
    }) {
        return await this.$api.orders.addMaterials(id, form)
    },

    async sendSms(_, {
        id,
        form,
    }) {
        return await this.$api.orders.sendSms(id, form)
    },

    async rejectOrder(_, {
        id,
        form,
    }) {
        try {
            const response = await this.$api.orders.rejectOrder(id, form)
            return response.status === 204
        } catch (err) {
            console.log(err)
        }
    },

    async updateRequestService(_, {
        id,
        service_id,
    }) {
        try {
            const response = await this.$api.orders.updateService(id, {
                service_id,
            })
            return response.status === 204
        } catch (err) {
            console.log(err)
        }
    },
}

const getters = {
    ordersGetters: (state) => state.orders,
    orderGetters: (state) => state.order,
    paramsGetters: (state) => state.params,
    selectSettingsGetters: (state) => state.selectSettings,
    newOrdersGetters: (state) => state.newOrders,
    showModal: (state) => state.showModal,
    statusesGetters: (state) => state.statuses,
    loadGetters: (state) => state.load,
    snackbar: (state) => state.snackbar,
    extraPrices: (state) => state.extraPrices,
    availableDays: (state) => state.availableDays,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
